
import { Tween } from '../../Tween';
import SpinModel from '../../model/SpinModel';
import { DefaultLayers } from '../../utils/Layers';
import ViewManager from '../../utils/ViewManager'
import CascadeReelGroup from '../../views/CascadeReelGroup';
import { State } from '../State';
/**
* Exit of this state must be when all symbols are exploded !
*/
export default class CascadeExplodeWinningsState extends State {
    /**
     * Value must be in ms
     */
    protected delayToExit: number = 50;
    /**
     * If set value bigger then 0, logic will be use this value for calculated exit time.
     * If this value will be set on 0 or lease, for calculation will be used CascadeReelCroup.getPoppedSymbolsAnimationDuration().
     * Value must be in ms
     */
    protected animationTime: number = 0;
    /**
     * Value must be in ms
     */
    protected explodedAnimDuration: number = 700;
    protected reelGroup: CascadeReelGroup;

    public enter(): void {
        super.enter();
        this.init();
    }
    /**
     * Put here all logic called after enter of the state
     */
    protected init(): void {
        this.reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as CascadeReelGroup;

        // Clear win lines and info
        this.reelGroup.hideLinesAndInfo(true);

        // Set up delay to exit
        this.setExitDelayTween();
        // Remove the winning symbols
        this.reelGroup.popSymbols(SpinModel.getCurrentCascadeExplodeMap());
    }
    /**
     * Set up a delay call tween for exit of this state
     */
    protected setExitDelayTween(): void {
        Tween.delayedCall(this.getStateDuration(), () => this.exit())
    }

    /**
     * @returns Duration time needed to explode all symbols in ms (1000ms = 1s)
     */
    protected getPoppedSymbolsAnimationDuration(): number {
        // Animation time of exploded
        return this.explodedAnimDuration
    }
    /**
     * @returns Duration time in this state in seconds (1000ms = 1s)
     */
    protected getStateDuration(): number {
        return (this.getExitDelay() + this.getPoppedSymbolsAnimationDuration()) / 1000
    }
    /**
     * @returns Delay for exit of the state after animations complete in seconds (1000ms = 1s)
     */
    protected getExitDelay(): number {
        return this.delayToExit
    }
}
